<script>
  import appConfig from "@/app.config";
  import PageHeader from "@/components/page-header";
  import Layout from "@/router/layouts/main";
  import Faq from "./Faq";
  import Book from "./Book";
  
  /**
   * Starter component
   */
  export default {
    page: {
      title: "Bantuan",
      meta: [{ name: "description", content: appConfig.description }],
    },
    components: {
      Layout,
      PageHeader,
      Faq,
      Book
    },
  
    computed: {
      title() {
        return `${this.$t("menuitems.help.text")}`;
      },
    }
  };
  </script>
        
  <template>
    <Layout>
      <div class="mc-list-header">
        <PageHeader :title="title" />
        <p class="mb-4">{{ $t("help.description") }}  </p>
      </div>
  
      <form>
        <b-card class="mc-card__setting">
            <b-tabs content-class="p-3 text-muted" nav-wrapper-class="mc-tab">
              <Book status="Book" ref="book" />
              <Faq status="Faq" ref="faq" />
            </b-tabs>
        </b-card>
      </form>
  
    </Layout>
  </template>